module.exports = __webpack_public_path__ + "static/media/img-9.93ac9b02.jpg";